import React from "react";
import {observer} from "mobx-react";
import {GamesOpenSessionRecordsContainerBox} from "./boxes/records-container/games-open-session-records-container.box";
import {IGameOpenSessionViewModel} from "../../services/games-open-sessions/games-open-session.service.interface";
import {GamesOpenSessionRecordComponent} from "./record/games-open-session-record.component";
import {CyClass} from "../../../common/cy-classes";


interface GamesOpenSessionsRecordsContainerComponentProps {
    openSessions: IGameOpenSessionViewModel[];
}

export const GamesOpenSessionsRecordsContainerComponent: React.FC<GamesOpenSessionsRecordsContainerComponentProps> = observer((props) => {
    return (
        <GamesOpenSessionRecordsContainerBox className={CyClass('cy-open-session-records')}>
            {props.openSessions.map(os => (<GamesOpenSessionRecordComponent key={os.sessionId} openSession={os}/>))}
        </GamesOpenSessionRecordsContainerBox>
    )
})


